import React from 'react'
import Header from '../Components/Header/Header'
import Hero from '../Components/Hero/Hero'
import Featuredbox from '../Components/Featuredbox/Featuredbox'
import Carouselvideo from '../Components/Carouselvideo/Carouselvideo'
import Callaction from '../Components/Callaction/Callaction'
import Video from '../Components/Video/Video'
import Servicebox from '../Components/Servicebox/Servicebox'
import { Counterbox } from '../Components/Counterbox/Counterbox'
import Coursebox from '../Components/Coursebox/Coursebox'
import Iconbox from '../Components/Iconbox/Iconbox'
import Coursecard from '../Components/Coursecard/Coursecard'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Authabout from '../Components/Authabout/Authabout'
import Carouselbox from '../Components/Carouselbox/Carouselbox'
import Faqsec from '../Components/Faqsec/Faqsec'
import Blogsec from '../Components/Blogsec/Blogsec'
import Recruitersec from '../Components/Recruitersec/Recruitersec'
import Reviewsec from '../Components/Reviewsec/Reviewsec'
import Partnersec from '../Components/Partnersec/Partnersec'
import Footer from '../Components/Footer/Footer'
import Appsec from '../Components/Appsec/Appsec'
import Videoreview from '../Components/Videoreviewsec/Videoreview'
import Corefeature from '../Components/Corefeature/Corefeature'
import Videoslilder from '../Components/VideoSlider/Videoslider'
import Slidericon from '../Components/SliderIcon/Slidericon'
import Whyneed from '../Components/Whyneed/Whyneed'
import Uniquefea from '../Components/UniqueFea/Uniquefea'
import Accordion from 'react-bootstrap/Accordion'


const Home = () => {
  return (
    <div>
    <Header/>
    <Hero/>
    <Slidericon/>
    <div class="container text-center ws-section">
        <div class="row">
            <div class="col-lg-12">
                <h2 class="ws-section_heading pd-03">Welcome to Takshila VLSI<br/>
                Watch Our Free Demo Sessions</h2>
            </div>
        </div>
        </div>
    <Videoslilder/>
    <Callaction/>
    <Video/>
    <Counterbox/>
    <Coursebox/>
    <Servicebox/>
    <Iconbox/>
    <Coursecard/>
    <Corefeature/>
    <Uniquefea/> 
    <Carouselbox/>
    <Faqsec/>
    <Blogsec/>
    <Recruitersec/>
    <Reviewsec/>
    <Appsec/> 
    <Videoreview/>
    <Enrollaction/> 
    <Partnersec/> 
    <Whyneed/> 
    <div class="faq-section ws-section pb-lg-5">
                <div class="container">
                    <div class="row pb-5">
                        
                        <div class="col-lg-12 align-self-center">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. How can I choose the right specialization based on my career goals?</Accordion.Header>
                                <Accordion.Body>
                                The right specialization depends on your educational background, interests, and long-term objectives. Institutes like Takshila VLSI often provide guidance to help students identify the most suitable learning path based on current industry requirements.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. What skills are employers looking for in entry-level semiconductor engineers?</Accordion.Header>
                                <Accordion.Body>
Employers generally seek candidates with strong technical fundamentals, practical project experience, analytical thinking, problem-solving abilities, and familiarity with industry-standard tools and workflows.                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. How important is hands-on training when preparing for a technical career?</Accordion.Header>
                                <Accordion.Body>
Hands-on training is essential because it helps learners apply theoretical concepts to real-world scenarios, gain confidence with tools, and develop practical skills that employers value.                                </Accordion.Body>
                            
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. What should I consider before enrolling in a technical training program?</Accordion.Header>
                                <Accordion.Body>
Key factors include trainer expertise, curriculum relevance, access to practical projects, learning resources, mentorship opportunities, and the availability of career support services.                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. How can structured training help bridge the gap between academics and industry?</Accordion.Header>
                                <Accordion.Body>
                                Structured training combines theoretical knowledge with practical exposure, helping students understand industry expectations, improve technical competency, and become more job-ready.
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                    
                    
        </div>
    </div>
   
    <Footer/> </div>
  )
}

export default Home